import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

export default function SuccessCheckout({ baseUrl }) {
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const sessionId = searchParams.get("session_id");
        const clientUid = searchParams.get("client_uid");
        const customerUid = searchParams.get("customer_uid");

        if (sessionId && clientUid && customerUid) {
            var formData = new FormData();
            formData.append("session_id", sessionId);
            formData.append("client_uid", clientUid);
            formData.append("customer_uid", customerUid);

            axios.post(baseUrl + "/successCheckoutWalletCreditStripe", formData)
                .then(res => {
                    console.log("Stripe confirm:", res.data);

                    // ✅ Fire success alert
                    Swal.fire({
                        icon: "success",
                        title: "Betaling godkjent",
                        text: "Takk for betalingen din, saldoen din er oppdatert.",
                        confirmButtonText: "OK",
                    }).then(() => {
                        if (window.opener) {
                            try {
                                window.opener.postMessage(
                                    { type: "WALLET_TOPUP", amount: res.data.amount, method: "card" },
                                    "*" // 👈 or restrict to your domain e.g. "http://localhost:3000"
                                );
                            } catch (e) {
                                console.error("Could not send top-up message:", e);
                            }
                            window.close();
                        }
                    });

                })
                .catch(err => {
                    console.error("Stripe confirm error:", err);
                    Swal.fire({
                        icon: "error",
                        title: "Feil",
                        text: "Noe gikk galt med betalingen. Vennligst prøv igjen.",
                    });
                });
        }
    }, [searchParams]);

    return (
        <div className="p-6 text-center">
            <h1 className="text-xl font-bold">Bekrefter betaling...</h1>
            <p>Vennligst vent et øyeblikk.</p>
        </div>
    );
}
